export const safelyGetPathFromUrl = (maybeUrl: string): string => {
  try {
    const parsedUrl = new URL(maybeUrl, 'https://dummy-base.com')
    return parsedUrl.pathname
  } catch (error) {
    return maybeUrl
  }
}
